// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-containerCommon {
  width: 100%;
  max-width: 400px;
  margin: 80px auto;
  background-color: #f9f9f9;
  padding: 30px 25px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-top: 0px;
  box-sizing: border-box;
}


.name {
  text-align: center;
  margin-bottom: 25px;
}

.form-row {
  display: flex;
  /* gap: -20px; */
  /* margin-bottom: 15px; */
}

.form-group {
  flex: 1 1;
  margin-bottom: 15px;
}

.form-group input,
.form-group.full-width input {
  width: 95%;
  padding: 12px;
  font-size: 15px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-sizing: border-box;
  transition: border-color 0.3s;
  /* margin-right: 20px; */
  /* margin-bottom: 15px; */
}

.form-group input:focus {
  border: 2px solid #2865aa;
  outline: none;
}

.form-group.full-width {
  margin-bottom: 15px;
}

.radio-section {
  margin: 20px 0;
}

.section-label {
  font-weight: bold;
  margin-bottom: 10px;
  display: block;
}

.radio-options {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  /* margin-right: 20px; */
}

.btnOne {
  width: 100%;
  padding: 12px;
  background-color: #2865AA;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  justify-content: center;
  align-items: center;
}

.btnOne:hover {
  background-color: #5390d9;
}

/* Responsive */
@media (max-width: 768px) {
  .form-containerCommon {
    /* margin: 10px 15px; */
    /* padding: 20px 15px; */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }  
  .form-row {
    flex-direction: column;
    /* gap: 8px; */
  }

  .form-group {
    margin-bottom: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/adduser.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;EACf,sBAAsB;AACxB;;;AAGA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;IACvB,wBAAwB;IACxB,uCAAuC;EACzC;EACA;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".form-containerCommon {\n  width: 100%;\n  max-width: 400px;\n  margin: 80px auto;\n  background-color: #f9f9f9;\n  padding: 30px 25px;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  margin-top: 0px;\n  box-sizing: border-box;\n}\n\n\n.name {\n  text-align: center;\n  margin-bottom: 25px;\n}\n\n.form-row {\n  display: flex;\n  /* gap: -20px; */\n  /* margin-bottom: 15px; */\n}\n\n.form-group {\n  flex: 1;\n  margin-bottom: 15px;\n}\n\n.form-group input,\n.form-group.full-width input {\n  width: 95%;\n  padding: 12px;\n  font-size: 15px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  box-sizing: border-box;\n  transition: border-color 0.3s;\n  /* margin-right: 20px; */\n  /* margin-bottom: 15px; */\n}\n\n.form-group input:focus {\n  border: 2px solid #2865aa;\n  outline: none;\n}\n\n.form-group.full-width {\n  margin-bottom: 15px;\n}\n\n.radio-section {\n  margin: 20px 0;\n}\n\n.section-label {\n  font-weight: bold;\n  margin-bottom: 10px;\n  display: block;\n}\n\n.radio-options {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  /* margin-right: 20px; */\n}\n\n.btnOne {\n  width: 100%;\n  padding: 12px;\n  background-color: #2865AA;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  justify-content: center;\n  align-items: center;\n}\n\n.btnOne:hover {\n  background-color: #5390d9;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .form-containerCommon {\n    /* margin: 10px 15px; */\n    /* padding: 20px 15px; */\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  }  \n  .form-row {\n    flex-direction: column;\n    /* gap: 8px; */\n  }\n\n  .form-group {\n    margin-bottom: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
